import React from 'react';
import PropTypes from 'prop-types';

export default function HomeIcon({ className = 'h-[18px] w-[18px]', strokeWidth = 1.6 }) {
  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      width='18'
      height='18'
      viewBox='0 0 24 24'
      fill='none'
      stroke='currentColor'
      strokeWidth={strokeWidth}
      strokeLinecap='round'
      strokeLinejoin='round'
      className={className}
    >
      <path d='M3 12l9-9 9 9M5 10v10h14V10' />
    </svg>
  );
}

HomeIcon.propTypes = {
  className: PropTypes.string,
  strokeWidth: PropTypes.number,
};
